module.exports = __webpack_public_path__ + "static/img/chanpin_pic.f64536a4.png";